<p-toast></p-toast>

<app-page-shell>

    <app-page-hero
        eyebrow="Fleet Assets"
        title="Trailers"
        subtitle="Manage uniquely identified trailer fleet assets for mobilization assignments.">
        <div actions>
            <p-button label="New Trailer" icon="pi pi-plus" (onClick)="create()"></p-button>
        </div>
    </app-page-hero>

    <app-page-search-panel
        title="Trailer Search"
        [activeFilters]="activeFilterCount()"
        [resultText]="totalRecords + ' trailers found'"
        [collapsed]="false"
        (search)="search()"
        (clear)="clearSearch()">
        <div class="search-grid">
            <div class="field">
                <label for="trailer-keyword">Keyword</label>
                <input id="trailer-keyword" pInputText [(ngModel)]="keyword" placeholder="Asset, plate, registration, type" />
            </div>
            <div class="field">
                <label for="trailer-type">Trailer Type</label>
                <p-select inputId="trailer-type" [options]="trailerTypes" [(ngModel)]="trailerTypeId" optionLabel="name" optionValue="trailerTypeId"
                    [showClear]="true" [filter]="true" filterBy="code,name" placeholder="Any type" appendTo="body" styleClass="w-full"></p-select>
            </div>
            <div class="field">
                <label for="trailer-status">Status</label>
                <p-select inputId="trailer-status" [options]="statusOptions" [(ngModel)]="status" optionLabel="label" optionValue="value"
                    [showClear]="true" placeholder="Any status" appendTo="body" styleClass="w-full"></p-select>
            </div>
            <div class="field">
                <label for="trailer-active">Active</label>
                <p-select inputId="trailer-active" [options]="activeOptions" [(ngModel)]="active" optionLabel="label" optionValue="value"
                    [showClear]="true" placeholder="Any active flag" appendTo="body" styleClass="w-full"></p-select>
            </div>
        </div>
    </app-page-search-panel>

    <app-page-metric-strip [metrics]="metrics()"></app-page-metric-strip>

    <app-page-data-panel title="Trailer Directory" subtitle="Trailer assets available to fleet mobilization." [resultText]="totalRecords + ' total'">
        <p-table [value]="rows" [lazy]="true" [paginator]="true" [rows]="rowsPerPage" [first]="first"
            [totalRecords]="totalRecords" [loading]="isLoading" [rowsPerPageOptions]="[10, 20, 50]"
            (onLazyLoad)="loadTrailers($event)" styleClass="p-datatable-sm" responsiveLayout="scroll">
            <ng-template pTemplate="header">
                <tr>
                    <th>Asset</th>
                    <th>Type</th>
                    <th>Registration</th>
                    <th>Status</th>
                    <th>Active</th>
                    <th>Expiry</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
                <tr>
                    <td>
                        <div class="stacked-cell">
                            <span class="font-semibold">{{ row.assetNumber || '-' }}</span>
                            <small>{{ row.plateNumber || '-' }}</small>
                        </div>
                    </td>
                    <td>
                        <div class="stacked-cell">
                            <span>{{ row.trailerTypeName || '-' }}</span>
                            <small>{{ row.trailerTypeCode || '-' }}</small>
                        </div>
                    </td>
                    <td>
                        <div class="stacked-cell">
                            <span>{{ row.registrationNumber || '-' }}</span>
                            <small>{{ row.plateNumber || '-' }}</small>
                        </div>
                    </td>
                    <td>
                        <div class="stacked-cell">
                            <p-tag [value]="row.status || 'AVAILABLE'" [severity]="statusSeverity(row.status)"></p-tag>
                            <p-select [options]="statusOptions" [ngModel]="row.status || 'AVAILABLE'" optionLabel="label" optionValue="value"
                                appendTo="body" styleClass="w-full" [disabled]="isStatusUpdating(row)"
                                (onChange)="updateStatus(row, $event.value)"></p-select>
                        </div>
                    </td>
                    <td>
                        <div class="stacked-cell">
                            <p-tag [value]="row.active === false ? 'Inactive' : 'Active'" [severity]="activeSeverity(row)"></p-tag>
                            <p-select [options]="activeOptions" [ngModel]="row.active !== false" optionLabel="label" optionValue="value"
                                appendTo="body" styleClass="w-full" [disabled]="isActiveUpdating(row)"
                                (onChange)="updateActive(row, $event.value)"></p-select>
                        </div>
                    </td>
                    <td>
                        <div class="stacked-cell">
                            <span>Reg: {{ dateLabel(row.registrationExpiry) }}</span>
                            <small>Ins: {{ dateLabel(row.insuranceExpiry) }}</small>
                        </div>
                    </td>
                    <td class="row-actions">
                        <p-button icon="pi pi-eye" [rounded]="true" [text]="true" (onClick)="view(row)" ariaLabel="View trailer"></p-button>
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary" (onClick)="edit(row)" ariaLabel="Edit trailer"></p-button>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7" class="empty-cell">No trailers found.</td>
                </tr>
            </ng-template>
        </p-table>
    </app-page-data-panel>
</app-page-shell>
